export var diamondBackground = '$_1WcSr';
export var cardSkeuomorphism = 'rhQyi';
export var cardImageMaxWidth = 'gyGKp';